import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getBasePath } from './utils/basePath';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const link: HTMLLinkElement | null = document.querySelector("link[rel='icon']");
if (link) {
  link.href = `${getBasePath()}favicon.png`;
}

reportWebVitals();
